import { render, staticRenderFns } from "./AddFundsFaq.vue?vue&type=template&id=2a29d040&"
import script from "./AddFundsFaq.vue?vue&type=script&lang=js&"
export * from "./AddFundsFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports